/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import "./BirthdayCard.css";
import EditableImage from "./EditableImage";
import EditableText from "./EditableText";
import Sidebar from "./SidebarMenu";
// import TopBar from "./TopBar";
import BottomBar from "./BottomBar";
import { useCard } from "context/CardContext";
import BirthdayCardModal from "components/birthday/BirthdayCardModal";

const BirthdayCard = () => {
  const {
    templates,
    texts,
    images,
    // backgroundColor,
    backgroundImage,
    activeTemplate,
    activeId,
    loading,
    handleEvents,
  } = useCard();

  return (
    <div id="outer-birthday-card">
      {loading && (
        <div className="preloader-container">
          <div className="preloader-wrapper small active">
            <div className="spinner-layer spinner-white">
              <div className="circle-clipper left">
                <div className="circle"></div>
              </div>
              <div className="gap-patch">
                <div className="circle"></div>
              </div>
              <div className="circle-clipper right">
                <div className="circle"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div id="birthday-card-container" onClick={handleEvents.OnEditEnd}>
        {/* <TopBar
          exportCardAsImage={handleEvents.OnExportCardAsImage}
          handleSendEmail={handleEvents.OnSendEmail}
        /> */}
        <Sidebar
          handleImageUpload={handleEvents.OnImageUpload}
          handleAddText={handleEvents.OnAddText}
          templates={templates}
          activeTemplate={activeTemplate}
          setActiveTemplate={handleEvents.OnSetActiveTemplate}
        />
        {/* <div
          id="canvas-preview"
          style={{ marginTop: "20px", border: "1px solid #ddd" }}
        ></div> */}
        <div>
          <div
            id="birthday-card"
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            onClick={handleEvents.OnEditEnd}
          >
            {/* Content Layer */}
            <div style={{ position: "relative", zIndex: 1 }}>
              {texts.map((text) => (
                <EditableText
                  key={text.id}
                  text={text}
                  isActive={activeId === text.id}
                  onSetActive={() => handleEvents.OnSetActive(text.id)}
                  onUpdate={handleEvents.OnUpdateText}
                  onRemove={() => handleEvents.OnRemoveText(text.id)}
                />
              ))}

              {images.map((image) => (
                <EditableImage
                  key={image.id}
                  image={image}
                  isActive={activeId === image.id}
                  onSetActive={() => handleEvents.OnSetActive(image.id)}
                  onUpdate={handleEvents.OnUpdateImage}
                  onRemove={() => handleEvents.OnRemoveImage(image.id)}
                />
              ))}
            </div>
          </div>
          <BottomBar
            exportCardAsImage={handleEvents.OnExportCardAsImage}
            handleSendEmail={handleEvents.OnSendEmail}
            handleEditBackground={handleEvents.OnEditBackground}
          />
        </div>
      </div>
      <BirthdayCardModal />
    </div>
  );
};

export default BirthdayCard;
